import { PositionModel } from '../Generated/Commodity-Management-Api';

export class PositionCalculations {

    public static weightedAveragePrice(positions: PositionModel[], openVolume: number) {
        const positionsVolume = positions.reduce((acc, pos) => acc + (pos.volume * (pos.side == "Buy" ? 1 : -1) || 0), 0);
        const positionValue = positions.reduce((acc, pos) => acc + ((pos.price || 0) * (pos.volume * (pos.side == "Buy" ? 1 : -1) || 0)), 0);
        const mtmValue = positions.reduce((acc, pos) => acc + (pos.markToMarketValue || 0), 0);
        const mtmPrice = positions.reduce((acc, pos) => acc + (pos.markToMarketPrice || 0) * (pos.volume * (pos.side == "Buy" ? 1 : -1) || 0), 0);
        const marketValue = positions.reduce((acc, pos) => acc + ((pos.marketPrice || 0) * (pos.volume * (pos.side == "Buy" ? 1 : -1) || 0)), 0);

        return {
            weightedAveragePrice: positionsVolume === 0 ? 0 : positionValue / positionsVolume,
            totalVolume: positionsVolume,
            mtmValue: mtmValue,
            mtmPrice: positionsVolume === 0 ? 0 : mtmPrice / positionsVolume,
            blendedPrice: ((positionsVolume === 0 ? 0 : marketValue / positionsVolume * openVolume) + positionValue) / (openVolume + positionsVolume),
            positionValue: positionValue
        }
    }

}